<template>
  <div class="boss-message-wrap">
    <applicant-message-attachment-files
      :summary-files="summaryFiles"
      :entry-id="entryId"
      @fetchAllMessage="fetchAllMessage"
    />
    <applicant-message-reservation-reserved-to-applicant
      v-if="messageReservationReserved"
      :message-reservation="messageReservationReserved"
      :entry-id="entryId"
      @setMessage="setMessage"
      @fetchAllMessage="fetchAllMessage"
    />
    <applicant-message-reservation-canceled-to-applicant
      v-if="messageReservationCanceled"
      :message-reservation="messageReservationCanceled"
      :entry-id="entryId"
      :is-withdraw="isWithdraw"
      @setMessage="setMessage"
      @fetchAllMessage="fetchAllMessage"
    />
    <template v-for="(message, i) in renderingAllMessage">
      <template v-if="message.key === historyFromKey">
        <!-- ▼ 応募者からのメッセージ -->
        <applicant-message-history-from-applicant
          :key="i"
          :body="message.body"
          :subject="message.subject"
          :date="message.date"
          :is-reserved="messageReservationReserved !== null"
          :is-withdraw="isWithdraw"
          @setMessage="setMessage"
        />
        <!-- ▲ 応募者からのメッセージ -->
      </template>
      <template v-else-if="message.key === historyToKey">
        <!-- ▼ 応募者へのメッセージ -->
        <applicant-message-history-to-applicant
          :key="i"
          :body="message.body"
          :subject="message.subject"
          :date="message.date"
          :is-read="message.isRead"
          :files="message.files"
          :interview-adjustment="message.interviewAdjustment"
        />
        <!-- ▲ 応募者へのメッセージ -->
      </template>
      <template v-else-if="message.key === historyEntryKey">
        <!-- ▼ 応募 -->
        <applicant-message-history-entry
          :key="i"
          :date="message.date"
          :first-name="message.firstName"
          :last-name="message.lastName"
          :job="message.job"
          :special-favors="message.specialFavors"
        />
        <!-- ▲ 応募 -->
      </template>
      <template v-else-if="message.key === historyPhaseKey">
        <!-- ▼ フェーズ -->
        <applicant-message-history-phase
          :key="i"
          :date="message.date"
          :phase-name="message.phaseName"
        />
        <!-- ▲ フェーズ -->
      </template>
      <template v-else-if="message.key === historyStatusKey">
        <!-- ▼ ステータス -->
        <applicant-message-history-status
          :key="i"
          :date="message.date"
          :status-name="message.statusName"
        />
        <!-- ▲ ステータス -->
      </template>
      <template v-else-if="message.key === historyScoutKey">
        <!-- ▼ スカウト -->
        <applicant-message-history-scout
          :key="i"
          :body="message.body"
          :subject="message.subject"
          :date="message.date"
          :job="message.job"
          :expiration-date="message.expirationDate"
          :special-favors="message.specialFavors"
        />
        <!-- ▲ スカウト -->
      </template>
    </template>
    <div
      v-if="hasScoutMessageSecondAndOver && !isShowAllMessage"
      class="boss-more-button"
    >
      <a
        href="javascript:void(0)"
        class="boss-button"
        data-test="read-more"
        @click="onShowAllMessage"
      >
        <span class="boss-more-button-text">もっと見る</span>
      </a>
    </div>
  </div>
</template>

<script>
import ApplicantMessageReservationReservedToApplicant from '@/components/molecules/ApplicantMessageReservationReservedToApplicant'
import ApplicantMessageReservationCanceledToApplicant from '@/components/molecules/ApplicantMessageReservationCanceledToApplicant'
import ApplicantMessageHistoryToApplicant from '@/components/molecules/ApplicantMessageHistoryToApplicant'
import ApplicantMessageHistoryFromApplicant from '@/components/molecules/ApplicantMessageHistoryFromApplicant'
import ApplicantMessageHistoryEntry from '@/components/molecules/ApplicantMessageHistoryEntry'
import ApplicantMessageHistoryPhase from '@/components/molecules/ApplicantMessageHistoryPhase'
import ApplicantMessageHistoryStatus from '@/components/molecules/ApplicantMessageHistoryStatus'
import ApplicantMessageHistoryScout from '@/components/molecules/ApplicantMessageHistoryScout'
import ApplicantMessageAttachmentFiles from '@/components/organisms/ApplicantMessageAttachmentFiles'
import _ from 'lodash'

export default {
  components: {
    ApplicantMessageReservationReservedToApplicant,
    ApplicantMessageReservationCanceledToApplicant,
    ApplicantMessageHistoryToApplicant,
    ApplicantMessageHistoryFromApplicant,
    ApplicantMessageHistoryEntry,
    ApplicantMessageHistoryPhase,
    ApplicantMessageHistoryStatus,
    ApplicantMessageHistoryScout,
    ApplicantMessageAttachmentFiles
  },
  props: {
    entryId: {
      type: Number,
      required: true
    },
    isWithdraw: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      allMessages: [],
      historyFromKey: 'from',
      historyToKey: 'to',
      historyEntryKey: 'entry',
      historyPhaseKey: 'phase',
      historyStatusKey: 'status',
      historyScoutKey: 'scout',
      isShowAllMessage: false,
      summaryFiles: [],
      messageReservationReserved: null,
      messageReservationCanceled: null
    }
  },
  computed: {
    hasScoutMessageSecondAndOver () {
      const scoutIndex = _.findIndex(this.allMessages, ['key', this.historyScoutKey])
      return scoutIndex >= 0 && this.allMessages.length - 1 > scoutIndex
    },
    renderingAllMessage () {
      return this.isShowAllMessage || _.findIndex(this.allMessages, ['key', this.historyScoutKey]) < 0 ? this.allMessages
        : this.allMessages.slice(0, _.findIndex(this.allMessages, ['key', this.historyScoutKey]) + 1)
    }
  },
  watch: {
    entryId: {
      handler () {
        this.fetchAllMessage()
      }
    }
  },
  created () {
    this.fetchAllMessage()
  },
  methods: {
    fetchAllMessage () {
      this.$set(this, 'summaryFiles', [])
      Promise.all([
        this.fetchFromCandidateMessage(),
        this.fetchToCandidateMessage(),
        this.fetchEntryMessage(),
        this.fetchPhaseMessage(),
        this.fetchStatusMessage(),
        this.fetchScoutMessage(),
        this.fetchMessageReservationReserved(),
        this.fetchMessageReservationCanceled()
      ]).then((response) => {
        const allMessage = [
          ...response[0].data.map(message => { return this.addKey(message, this.historyFromKey) }),
          ...response[1].data.map(message => {
            this.summaryFiles.push(..._.get(message, 'files', []).map(file => _.set(file, 'sentDate', message.date)))
            return this.addKey(message, this.historyToKey)
          }),
          !_.isNull(response[2].data) && this.addKey(response[2].data, this.historyEntryKey),
          ...response[3].data.map(message => { return this.addKey(message, this.historyPhaseKey) }),
          ...response[4].data.map(message => { return this.addKey(message, this.historyStatusKey) }),
          ...response[5].data.map(message => { return this.addKey(message, this.historyScoutKey) })
        ]
        this.$set(this, 'allMessages', _.orderBy(allMessage, ['date'], ['desc']))
        this.setMessageReservationReserved(response[6].data)
        this.$set(this, 'messageReservationCanceled', response[7].data || null)
      })
    },
    async fetchMessageReservationReserved () {
      return this.$http.secured.get(`/entry/view/entries/${this.entryId}/message/reserved_reservation`)
    },
    async fetchMessageReservationCanceled () {
      return this.$http.secured.get(`/entry/view/entries/${this.entryId}/message/canceled_reservation`)
    },
    async fetchFromCandidateMessage () {
      return this.$http.secured.get(`/entry/view/entries/${this.entryId}/history/from_user_messages`)
    },
    async fetchToCandidateMessage () {
      return this.$http.secured.get(`/entry/view/entries/${this.entryId}/history/to_user_messages`)
    },
    async fetchEntryMessage () {
      return this.$http.secured.get(`/entry/view/entries/${this.entryId}/history/entries`)
    },
    async fetchPhaseMessage () {
      return this.$http.secured.get(`/entry/view/entries/${this.entryId}/history/phases`)
    },
    async fetchStatusMessage () {
      return this.$http.secured.get(`/entry/view/entries/${this.entryId}/history/phase_statuses`)
    },
    async fetchScoutMessage () {
      return this.$http.secured.get(`/entry/view/entries/${this.entryId}/history/scouts`)
    },
    addKey (value, key) {
      const copyValue = _.cloneDeep(value)
      copyValue.key = key
      return copyValue
    },
    setMessage (data) {
      this.$emit('setMessage', data)
    },
    onShowAllMessage () {
      this.$set(this, 'isShowAllMessage', true)
    },
    setMessageReservationReserved (reservedData) {
      this.$set(this, 'messageReservationReserved', reservedData || null)
      // 予約中データ変更毎に親にも通知
      this.$emit('setIsMessageReserved', !!reservedData)
    }
  }
}
</script>
